import React from 'react';
import InfoBox from '../../../widgets/InfoBox/InfoBox';
import './CompletedRenewalsPortalPage.css';
import PageBase from '../../../widgets/PageBase/PageBase';
import PropTypes from 'prop-types';
import { MenuItem, Select, Button } from '@material-ui/core';
import SearchBar from '../../../widgets/SearchBar/SearchBar';
import CompletedRenewalsTable from './CompletedRenewalsTable/CompletedRenewalsTable';
import { injectIntl } from 'react-intl';

const filterBox = (box, key) => (
  <div key={key} className="col-xs-12 col-sm-6 col-md-6 col-lg-4 m-b-15">
    <div onClick={box.onClick}>
      <InfoBox
        icon={box.icon}
        color={box.color}
        iconColor={box.iconColor}
        title={box.title}
        subtitle={box.subtitle}
        subvalue={box.subvalue}
        value={box.count}
      />
    </div>
  </div>
);

const filterBoxes = (props) => props.filterBoxes.map(filterBox);

const filterSelects = (props) => (
  <span className="row renewals-portal-filter-selects">
    <Select
      className="col-xs-12 col-sm-6 col-md-2 m-b-15"
      value={props.selectedRouteNumber}
      onChange={(event) => {
        event.preventDefault();
        props.onChangeRoute(event.target.value);
      }}
    >
      {props.routes.map((route, index) => (
        <MenuItem key={index} value={route.routeNumber}>
          {route.display}
        </MenuItem>
      ))}
    </Select>
    <Select
      className="col-xs-12 col-sm-6 col-md-2 m-b-15"
      value={props.selectedDistrictNumber}
      onChange={(event) => {
        event.preventDefault();
        props.onChangeDistrict(event.target.value);
      }}
    >
      {props.districts.map((district, index) => (
        <MenuItem key={index} value={district.districtId}>
          {district.display}
        </MenuItem>
      ))}
    </Select>
    {resetButtons(props)}
  </span>
);

const resetButtons = (props) => (
  <div className="row renewals-portal-filter-selects">
    <div className="btn-action btn-back btn-clear">
        <Button onClick={props.onClearFilters}>
          {props.intl.formatMessage({
            id: 'clear_reset'
          })}
        </Button>
      </div>
  </div>
);


class CompletedRenewalsPortalPage extends React.Component {
  constructor(props) {
    super(props);
    this.searchBarRef = React.createRef();
  }

  onClearSearch() {
    this.searchBarRef.current.onClearSearch();
  }

  render() {
    return (
      <PageBase
        navigation={[
          this.props.intl.formatMessage({
            id: 'completed_renewals_portal'
          })
        ]}
      >
        <div className="row completed-renewals-portal-header">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15 form-wrapper">
            <SearchBar
              ref={this.searchBarRef}
              onSearch={this.props.onCustomerSearch}
              placeHolder={this.props.intl.formatMessage({
                id: 'enter_customer_name_or_number'
              })}
            />
          </div>
        </div>
        <div className="row completed-renewals-portal-info">
          {filterBoxes(this.props)}
        </div>
        {!this.props.hideDropdown ? filterSelects(this.props) : resetButtons(this.props)}
        <CompletedRenewalsTable
          archivedRenewals={this.props.archivedRenewals}
          page={this.props.page}
          onChangePage={this.props.onChangePage}
          onChangeRowsPerPage={this.props.onChangeRowsPerPage}
          sortBy={this.props.sortBy}
          onRequestSort={this.props.onRequestSort}
        />
      </PageBase>
    );
  }
}

CompletedRenewalsPortalPage.propTypes = {
  onCustomerSearch: PropTypes.func.isRequired,
  archivedRenewals: PropTypes.array.isRequired,
  filterBoxes: PropTypes.array.isRequired,
  page: PropTypes.object.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  sortBy: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onChangeRoute: PropTypes.func.isRequired,
  onChangeDistrict: PropTypes.func.isRequired, 
  hideDropdown: PropTypes.func.isRequired
};

export default injectIntl(CompletedRenewalsPortalPage);
